import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ec0b704"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-form-cover" }
const _hoisted_2 = { class: "search_form__container" }
const _hoisted_3 = { class: "search_form__information" }
const _hoisted_4 = { class: "search_form__title" }
const _hoisted_5 = { class: "checkbox-feedback" }
const _hoisted_6 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "Perguntas: " + _toDisplayString(_ctx.currentPage) + "/" + _toDisplayString(_ctx.totalPages), 1)
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$props.question.question.title), 1),
      _createVNode(_component_TUIViewer, {
        "model-value": _ctx.$props.question.question.description
      }, null, 8, ["model-value"]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkboxOptions, (option) => {
          return (_openBlock(), _createElementBlock("label", {
            key: option.value,
            class: "checkbox-feedback__item"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: option.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCheckboxes) = $event)),
              disabled: _ctx.disabled
            }, null, 8, _hoisted_6), [
              [_vModelCheckbox, _ctx.selectedCheckboxes]
            ]),
            _createElementVNode("span", null, _toDisplayString(option.label), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}